import _ from 'lodash';
/**
 * Created by zoechodosh on 1/31/17.
 */
export const EventTypes = [
  {
    title: 'Welcome Event',
    value: 'WELCOME_EVENT'
  },
  {
    title: 'Rehearsal Dinner',
    value: 'REHEARSAL_DINNER'
  },
  {
    title: 'Wedding',
    value: 'WEDDING'
  },
  {
    title: 'Ceremony',
    value: 'CEREMONY'
  },
  {
    title: 'Reception',
    value: 'RECEPTION'
  },
  {
    title: 'After Party',
    value: 'AFTER_PARTY'
  },
  {
    title: 'Brunch',
    value: 'BRUNCH'
  },
  {
    title: 'Other',
    value: 'OTHER'
  }
];

export const getEventType = (eventType) => {
  const idx = _.findIndex(EventTypes, elem => (elem.value === eventType));
  return (idx >= 0) ? EventTypes[idx].title : '';
};



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EventTypes.js